import React from 'react';
import { FormControlLabel, Switch, SwitchProps } from '@mui/material';
import { Controller, useFormContext } from 'react-hook-form';

export type FormSwitchProps = Omit<SwitchProps, 'name'> & {
  name: string;
  label: string;
};

export const FormSwitch: React.FC<FormSwitchProps> = ({
  name,
  label,
  ...rest
}) => {
  const { control } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      render={({ field }) => (
        <FormControlLabel
          control={
            <Switch
              {...rest}
              checked={!!field.value}
              onChange={(e) => field.onChange(e.target.checked)}
            />
          }
          label={label}
        />
      )}
    />
  );
};
